// extracted by mini-css-extract-plugin
export default {"root":"CoursePauseRequestedRequestsTable_root__1t-f5","rows":"CoursePauseRequestedRequestsTable_rows__5vEd4","pagination":"CoursePauseRequestedRequestsTable_pagination__ZjHz-"};